import React, { useState } from 'react';
import { saveConnection } from '../services/api';
import axios from 'axios';

export default function Login({ onLogin }) {
  const [url, setUrl] = useState('https://facebook.psidirect.cz');
  const [key, setKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const baseUrl = url.replace(/\/$/, '');
      const res = await axios.get(`${baseUrl}/api/health`, {
        headers: { 'x-api-key': key },
        timeout: 8000,
      });
      if (res.data?.status === 'ok') {
        saveConnection(baseUrl, key);
        onLogin();
      } else {
        setError('Server neodpovídá správně.');
      }
    } catch (err) {
      if (err.response?.status === 401) {
        setError('Neplatný API klíč.');
      } else {
        setError('Nelze se připojit k serveru. Zkontrolujte URL.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F1EFE8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: 'white',
        borderRadius: 16,
        padding: '40px 36px',
        width: 380,
        boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="/logo.png" alt="P.S.I." style={{ width: 160, marginBottom: 16 }} />
          <div style={{ fontSize: 22, fontWeight: 800, color: '#185FA5' }}>P.S.I. prodejna</div>
          <div style={{ fontSize: 14, color: '#888', marginTop: 4 }}>Připojení k serveru</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#555', marginBottom: 6 }}>
              URL serveru
            </label>
            <input
              type="url"
              value={url}
              onChange={e => setUrl(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 12px', borderRadius: 8,
                border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box',
                outline: 'none',
              }}
              placeholder="https://facebook.psidirect.cz"
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#555', marginBottom: 6 }}>
              API klíč
            </label>
            <input
              type="text"
              value={key}
              onChange={e => setKey(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 12px', borderRadius: 8,
                border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box',
                fontFamily: 'monospace', outline: 'none',
              }}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
            />
          </div>

          {error && (
            <div style={{
              background: '#fff0f0', border: '1px solid #ffcdd2',
              borderRadius: 8, padding: '10px 14px',
              color: '#c62828', fontSize: 13, marginBottom: 16,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '13px',
              background: loading ? '#aaa' : '#185FA5',
              color: 'white', border: 'none', borderRadius: 10,
              fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.15s',
            }}
          >
            {loading ? 'Připojuji...' : 'Připojit'}
          </button>
        </form>
      </div>
    </div>
  );
}
